module.exports = __webpack_public_path__ + "static/dev102-f5335500384a64ec6a3d3f982a6d5fed.gif";